import React, { useState } from "react";
export default function About({ language, texts }) {

    return (
        <section className="w-full bg-[#fffaf0] py-16 px-6 md:px-12">
            <h2 className="text-2xl font-bold my-6 text-center">
                {language === "JP" ? "はなぴんって何？" : language === "ZH" ? "《樱花老师》是什么？" : "What Is"}
                <i> {language === "EN" ? "Hanapin" : ""}</i>
                {language === "EN" ? " ?" : ""}
            </h2>
            <div>
                {texts.about.hanapin}
            </div>
            <h2 className="text-2xl font-bold my-6 text-center">
                {language === "JP" ? "ふじやまについて" : language === "ZH" ? "关于 Fujiyama, Inc." : "About Fujiyama, Inc."}
            </h2>
            <div>{texts.about.fujiyama}</div>
            <h2 className="text-2xl font-bold my-6 text-center">
                {language === "JP" ? "所在地" : language === "ZH" ? "地址" : "Address"}
            </h2>
            <div><p>〒107-0061 東京都港区北青山一丁目3番1号 3階</p></div>
        </section>
    );
}
